var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9537 1.98192C13.4966 1.7866 12.9677 1.99879 12.7724 2.45586C12.5771 2.91293 12.7893 3.4418 13.2463 3.63712L13.9537 1.98192ZM6.75366 3.63712C7.21074 3.4418 7.42292 2.91293 7.2276 2.45586C7.03228 1.99879 6.50341 1.7866 6.04633 1.98192L6.75366 3.63712ZM10.9 1C10.9 0.502944 10.4971 0.1 10 0.1C9.50294 0.1 9.1 0.502944 9.1 1H10.9ZM9.1 7.33333C9.1 7.83039 9.50294 8.23333 10 8.23333C10.4971 8.23333 10.9 7.83039 10.9 7.33333H9.1ZM13.2463 3.63712C15.9645 4.79871 18.1 7.70795 18.1 10.9524H19.9C19.9 6.94062 17.2907 3.40796 13.9537 1.98192L13.2463 3.63712ZM18.1 10.9524C18.1 15.5222 14.4771 19.1 10 19.1V20.9C15.4715 20.9 19.9 16.5159 19.9 10.9524H18.1ZM10 19.1C5.52294 19.1 1.9 15.5222 1.9 10.9524H0.1C0.1 16.5159 4.52846 20.9 10 20.9V19.1ZM1.9 10.9524C1.9 7.70795 4.03548 4.79871 6.75366 3.63712L6.04633 1.98192C2.70932 3.40796 0.1 6.94062 0.1 10.9524H1.9ZM9.1 1V7.33333H10.9V1H9.1Z",
    fill: "#FF002E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5d21a05e0539ddb501d9159219f8a190.svg";
export { ForwardRef as ReactComponent };